<template>
  <div class="mobile-search">

    <header>
      <img class="logo" :src="logo" alt="logo" />
      <img @click="$emit('close')" :src="closeIcon" alt="logo"/>
    </header>

    <main>

      <div class="search-area-wrap">
        <div class="search-area">
          <img v-show="!keyword" :src="searchIcon" alt="search"/>
          <input type="text" :placeholder="this.$i18n.locale === 'zh-CN' ? '搜索' : 'Search'" v-model="keyword" />
          <i class="iconfont icon-micro" @click="openVoiceModal"></i>
        </div>
        <span class="cancel" v-show="keyword" @click="keyword = ''">{{ $i18n.locale === 'zh-CN' ? '取消' : 'cancel'}}</span>
      </div>

      <ul class="nav-list" v-if="!keyword">
        <li
          v-for="(list, index) in lists"
          :key="index"
          @click="expandList(list, index)"
          :class="{'actived': list.isSelected}">
          <div class="title">
            {{ $i18n.locale === 'zh-CN' ? list.title : list.title_en }}
            <img v-if="index !== 1" :src="arrowDown" alt="arrow"/>
          </div>
          <transition name="collapse">
            <div class="content" ref="content" v-show="list.isSelected">
              <span @click="$router.push({ name: item.name, path: item.path }); $emit('close')" v-for="(item, index) in list.content" :key="index + 1000">{{ $i18n.locale === 'zh-CN' ? item.title : item.title_en }}</span>
            </div>
          </transition>
        </li>

        <div class="language-toggle">
          <span :class="{ none: $i18n.locale !== 'zh-CN' }" @click="setLang('zh-CN')">中文</span>
          <span> | </span>
          <span :class="{ none: $i18n.locale === 'zh-CN' }" @click="setLang('en-US')">EN</span>
        </div>
      </ul>

      <div class="search-results" v-else>
        <ul class="categories">
          <li
            v-for="(cate, index) in categories"
            :key="index"
            :class="{ current: cate.type === category }"
            @click="category = cate.type">
              {{ $i18n.locale === 'zh-CN' ? cate.name : cate.name_en }}
          </li>
        </ul>

        <ul class="results">
          <li
            v-for="(result, index) in currentResults"
            :key="index"
            @click="viewResult(result)">
              <span class="label">{{ judgeCategory(result.category) }}</span>
              <span>{{ $i18n.locale === 'zh-CN' ?
                result.name || (result.article && (result.article.title || result.article.title_en)) :
                result.name_en || result.name || (result.article && (result.article.title_en || result.article.title)) }}</span>
          </li>
        </ul>
      </div>

    </main>

    <div class="voice-modal" v-if="showVoiceModal">
      <img :src="closeIcon" alt="logo" @click="closeVoiceModal" />

      <h2>说出你想找什么</h2>

      <template v-if="!isMsgVisible">
        <span class="top-span" v-show="step === 0">长按按钮开启语音识别</span>
        <span class="top-span" v-show="step === 1">
          <div>正在倾听...</div>
          <div class="release-up">松开停止录音...</div>
        </span>
        <span class="top-span" v-show="step === 2">正在识别中...</span>
      </template>

      <div class="top-span error" v-else>
        <span>没听清，试试说“研究院简介”</span>
        <ul class="rec">
          <li
            v-for="(item, index) in ['研究生培养', '研究方向', '新一代人工智能理论']"
            :key="index"
            @click="jumpSearch(item)">{{ item }}</li>
        </ul>
      </div>

      <div class="siri-wave" v-show="step === (1 || 2)"></div>
      <footer>
        <div class="bottom-span mic-btn" @touchstart="start" @touchend="endRecord">
          <i class="iconfont icon-micro"></i>
        </div>
      </footer>
    </div>

  </div>
</template>

<script>
import SiriWave from 'siriwave';
import Recorder from '@/utils/recorder';
import api from '@/api'
import { mapState, mapActions } from 'vuex'
import { getLang } from '@/utils';

const logo = require('@/assets/images/logo_Institute.svg');
const closeIcon = require('@/assets/images/close.svg');
const searchIcon = require('@/assets/images/search.svg');
const arrowDown = require('@/assets/images/arrow.svg');

const isWechat = (navigator.userAgent.toLowerCase().includes('micromessenger'));

export default {
  name: 'mobileSearch',

  data() {
    return {
      getLang,
      lang: this.$i18n.locale,
      logo,
      closeIcon,
      searchIcon,
      arrowDown,
      showVoiceModal: false,
      siriWave: null,
      stream: null,
      recorder: null,
      isMsgVisible: false,
      timerId: null,
      step: 0,
      keyword: '',
      isSearchResultVisible: false,
      category: 'all',
      clientWidth: document.body.clientWidth,
      lists: [
        {
          title: '研究院概况',
          title_en: 'About',
          content: [
            {
              title: '研究院简介',
              title_en: 'Overview',
              name: 'profile',
            },
            {
              title: '研究院领导',
              title_en: 'Leadership',
              name: 'leaders',
            },
            {
              title: '行政办公',
              title_en: 'Administrative Staff',
              name: 'office',
            }
          ],
          isSelected: false,
        },
        {
          title: '研究中心',
          title_en: 'Research Center',
          isSelected: false,
        },
        {
          title: '师资队伍',
          title_en: 'Faculty',
          content: [
            {
              title: '教师名录',
              title_en: 'Teacher directory',
              name: 'teachers',
            },
            {
              title: '杰出人才',
              title_en: 'Outstanding talent',
              name: 'talents',
            },
            {
              title: '博士后',
              title_en: 'Postdoctoral',
              name: 'postdoc',
            }
          ],
          isSelected: false,
        },
        {
          title: '新闻通告',
          title_en: 'News & Events',
          content: [
            {
              title: '新闻信息',
              title_en: 'News',
              path: '/info/news',
            },
            {
              title: '学术动态',
              title_en: 'Academic Activities',
              path: '/info/academic',
            },
            {
              title: '通知公告',
              title_en: 'Events',
              path: '/info/announcements',
            },
            {
              title: '招聘信息',
              title_en: 'Recruitment',
              path: '/info/jobs',
            },
          ],
          isSelected: false,
        },
        {
          title: '人才培养',
          title_en: 'Cultivate',
          content: [
            {
              title: '吴文俊人工智能荣誉博士班',
              title_en: 'Graduate',
              name: 'postgraduate',
            }
          ],
          isSelected: false,
        },
        {
          title: '科学研究',
          title_en: 'Research',
          content: [
            {
              title: '学科基地',
              title_en: 'Centers & Labs',
              name: 'bases',
            },
            {
              title: '科研成果',
              title_en: 'Achievements',
              name: 'results',
            },
          ],
          isSelected: false,
        },
      ],
      categories: [
        {
          name: '全部',
          name_en: 'All',
          type: 'all'
        },
        {
          name: '研究院概况',
          name_en: 'About',
          type: 'leaders',
        },
        {
          name: '研究中心',
          name_en: 'Research Center',
          type: 'center'
        },
        {
          name: '师资队伍',
          name_en: 'Faculty',
          type: 'teachers'
        },
        {
          name: '新闻通告',
          name_en: 'News & Events',
          type: 'news',
        },
        {
          name: '人才培养',
          name_en: 'Cultivate',
          type: 'cultivate',
        },
        {
          name: '科学研究',
          name_en: 'Research',
          type: 'research'
        }
      ],
    }
  },

  computed: {
    ...mapState('home', [
      'searchSA'
    ]),

    results() {
      const { searchSA } = this
      let sum = []
      Object.keys(searchSA).forEach((key) => {
        const list = searchSA[key].map(ele => Object.assign({}, ele))
        if (key === 'teachers' || key === 'leaders') {
          list.forEach((ele) => {
            ele.category = key
          })
        }
        sum = sum.concat(list)
      })
      return sum
    },

    currentResults() {
      const { results, category } = this

      if (category === 'all') {
        return results
      }

      if (category === 'leaders') {
        return results.filter(result => result.category === 'leaders')
      }

      if (category === 'teachers') {
        return results.filter(result => result.category === 'teachers')
      }

      if (category === 'news') {
        return results.filter(result =>
          result.category === 'Notice' ||
          result.category === 'News' ||
          result.category === 'Learning' ||
          result.category === 'Employment')
      }

      if (category === 'cultivate') {
        return results.filter(result => result.category === 'CultivateManage')
      }

      if (category === 'research') {
        return results.filter(result =>
          result.category === 'ResearchDirection' ||
          result.category === 'ResearchAwards' ||
          result.category === 'MajorAchievements' ||
          result.category === 'ResearchProjects' ||
          result.category === 'ResearchLightspot')
      }

      return []
    }
  },

  watch: {
    keyword(val, oldVal) {
      if (val === oldVal) { return }
      this.search(val)
    }
  },

  methods: {
    ...mapActions('home', [
      'searchScienceArticle'
    ]),

    setLang(value) {
      this.$i18n.locale = value
      localStorage.TB_APP_LANG = value
    },

    expandList(list, index) {
      // TODO
      if (index === 1) {
        this.$router.push('/center')
        return
      }
      if (index === 2) {
        return
      }
      if (list.isSelected) {
        list.isSelected = false;
        return;
      }
      this.lists.forEach((list) => {
        list.isSelected = false;
      });
      list.isSelected = !list.isSelected;
    },

    openVoiceModal() {
      this.showVoiceModal = true
    },

    closeVoiceModal() {
      if (this.stream && !isWechat) { this.stream.getAudioTracks()[0].stop(); }
      if (this.siriWave) { this.siriWave.stop() }
      this.showVoiceModal = false
      this.isMsgVisible = false
      this.recorder = null
      this.step = 0
    },

    async start() {
      // 创建 siriWave 动画
      if (!this.siriWave) {
        this.siriWave = new SiriWave({
          container: document.getElementsByClassName('siri-wave')[0],
          width: this.clientWidth,
          height: 200,
          style: 'ios9',
          // frequency: 100,
          amplitude: 2,
        });
      }

      // 创建录音
      if (!isWechat) {
        if (!this.recorder) {
          const AudioContext = window.AudioContext || window.webkitAudioContext
          const audioContext = new AudioContext()
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false })
          this.stream = stream
          // eslint-disable-next-line
          console.log('getUserMedia() success, stream created, initializing Recorder.js ...')
          const source = audioContext.createMediaStreamSource(stream)
          const config = {
            numChannels: 1,
            sampleRate: 16000,
            callback: () => {}
          }
          this.recorder = new Recorder(source, config)
        }
      }

      this.step = 1 // 录音中
      this.startRecord()
    },

    startRecord() {
      // 启动录音
      this.result = null
      this.isMsgVisible = false

      // 如果是在微信中，则用微信 jssdk 录音
      if (isWechat) {
        wx.startRecord(); // eslint-disable-line
      } else {
        this.recorder.record()
      }
      this.siriWave.start()
      // eslint-disable-next-line
      console.log('Recording started')

      // 限时结束
      this.timerId = setTimeout(this.endRecord, 10000)
    },

    endRecord() {
      this.step = 2 // 识别中

      if (this.timerId) {
        clearTimeout(this.timerId)
      }

      // 结束录音
      if (this.siriWave) { this.siriWave.stop() }
      if (this.recorder) { this.siriWave.stop() }
      // eslint-disable-next-line
      console.log('Recording ended')

      if (isWechat) {
        wx.stopRecord({ // eslint-disable-line
          success: (res) => {
            const localId = res.localId;
            wx.translateVoice({ // eslint-disable-line
              localId,
              isShowProgressTips: 0, // 默认为1，显示进度提示
              success: (res) => {
                let result = res.translateResult;
                if (result) {
                  // 去除结尾句号
                  if (result[result.length - 1] === '。') {
                    result = result.slice(0, -1);
                  }
                  this.jumpSearch(result);
                }
              }
            });
          }
        });
        return;
      }

      if (this.recorder) {
        this.recorder.exportWAV(async (blob) => {
          const formData = new FormData()
          formData.append('file', blob)

          const { result, err_msg: errMsg } = await api.audio.upload({ formData })
          this.step = 3 // 识别完成

          if (errMsg) {
            this.isMsgVisible = true
            return
          }
          this.jumpSearch(result)
        })
        this.recorder.clear()
      }
    },

    jumpSearch(keyword) {
      this.keyword = keyword
      if (!isWechat) {
        this.stream.getAudioTracks()[0].stop();
      }
      this.closeVoiceModal()
    },

    async search(keyword) {
      if (!keyword || keyword.trim().length === 0) {
        return
      }
      await this.searchScienceArticle({
        category: 'all',
        word: keyword.trim(),
      })
      this.isSearchResultVisible = true
    },

    judgeCategory(category) {
      let type = ''
      switch (category) {
        case 'ResearchDirection': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '科学研究 / 科学方向'
          } else {
            type = 'Research / Research directions'
          }
          break;
        }

        case 'CultivateManage': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '人才培养 / 吴文俊人工智能荣誉博士班'
          } else {
            type = 'Cultivate / Postgraduate cultivation'
          }
          break;
        }

        case 'ResearchAwards': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '科学研究 / 科研成果'
          } else {
            type = 'Research / Research results'
          }
          break;
        }

        case 'Notice': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '新闻通告 / 通知公告'
          } else {
            type = 'News and announcement / Announcement'
          }
          break;
        }

        case 'News': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '新闻通告 / 新闻信息'
          } else {
            type = 'News and announcement / News'
          }
          break;
        }

        case 'Learning': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '新闻通告 / 学术动态'
          } else {
            type = 'News and announcement / Academic development'
          }
          break;
        }

        case 'Employment': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '新闻通告 / 招聘信息'
          } else {
            type = 'News and announcement  /  Job Offers'
          }
          break;
        }

        case 'MajorAchievements': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '科学研究 / 科研成果'
          } else {
            type = 'Research / Research results'
          }
          break;
        }

        case 'ResearchProjects': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '科学研究 / 科研成果'
          } else {
            type = 'Research / Research results'
          }
          break;
        }

        case 'ResearchLightspot': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '科学研究 / 科研成果'
          } else {
            type = 'Research / Research results'
          }
          break;
        }

        case 'leaders': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '研究院概况 / 研究院领导'
          } else {
            type = 'About / AI Institute leadership'
          }
          break;
        }

        case 'center': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '研究中心'
          } else {
            type = 'Research Center'
          }
          break;
        }

        case 'teachers': {
          if (this.$i18n.locale === 'zh-CN') {
            type = '师资队伍'
          } else {
            type = 'Faculty'
          }
          break;
        }

        default:
          break;
      }

      return type
    },

    viewResult(result) {
      switch (result.category) {
        case 'ResearchDirection': {
          window.open('/research/directions')
          break;
        }

        case 'ResearchAwards': {
          // window.open(`/research/results-detail/award/${message.id}`)
          window.open('/research/results/award')
          break;
        }

        case 'ResearchProjects': {
          // window.open(`/research/results-detail/project/${message.id}`)
          window.open('/research/results/project')
          break;
        }

        case 'MajorAchievements': {
          // window.open(`/research/results-detail/result/${message.id}`)
          window.open('/research/results/important')
          break;
        }

        case 'ResearchLightspot': {
          // window.open(`/research/results-detail/paper/${message.id}`)
          window.open('/research/results/paper')
          break;
        }

        case 'CultivateManage': {
          window.open(`/cultivate/postgraduate/managements/${result.id}`)
          break;
        }

        case 'Learning': {
          window.open(`/info/academic/${result.id}`)
          break;
        }

        case 'Notice': {
          window.open(`/info/announcements/${result.id}`)
          break;
        }

        case 'News': {
          window.open(`/info/news/${result.id}`)
          break;
        }

        case 'Employment': {
          window.open(`/info/jobs/${result.id}`)
          break;
        }

        case 'leaders': {
          window.open('/about/leaders')
          break
        }

        case 'center': {
          window.open('/center')
          break
        }

        case 'teachers': {
          window.open(`/faculty/detail/${result.id}`)
          break
        }

        default:
          break;
      }
    },
  },
}
</script>

<style lang="less" scoped>
.mobile-search {
  z-index: 2;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  padding: 24px 24px 0;
  min-height: 100vh;
  color: white;
  //background: linear-gradient(0deg, #38286B 0%, #212149 100%);
  background-color: rgba(12, 18, 29, 0.98);

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12.5px;
    width: 100%;
    img {
      height: 16px;
    }
    .logo {
      height: 24px;
    }
  }

  main {
    font-size: 15px;
    line-height: 32px;
    color: #FFF;
    height: calc(~'100% - 55px');

    .search-area-wrap {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }

    .search-area {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 4px 0 12px 0;
      padding: 14px 0;
      border-bottom: 1px solid rgba(255,255,255,.1);

      input {
        padding: 0 4px;
        width: 100%;
        color: #FFF;
        background: inherit;
        //opacity: .4;
        //font-family: OpenSans;
        //font-size: 15px;
        &::placeholder {
          line-height: 22px;
        }
      }

      img {
        opacity: .4;
        width: 16px;
      }
    }

    .cancel {
      line-height: 20px;
      margin-left: 20px;
      white-space: nowrap;
    }

    ul {
      li {
        display: flex;
        flex-direction: column;
        padding: 9px 0;
        width: 100%;
        font-size: 15px;
        line-height: 32px;
        color: #FFF;
        //border-bottom: 1px solid #3F3362;
        border-bottom: 1px solid rgba(255,255,255,.05);

        .title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          img {
            opacity: .4;
            //transition: transform .4s;
          }
        }

        .content {
          display: flex;
          flex-direction: column;
          padding-left: 16px;
          padding-top: 12px;
          span {
            padding: 9px 0;
            opacity: .75;
          }
        }
      }

      .actived {
        border-bottom: none;
        .title {
          padding-bottom: 9px;
          border-bottom: 1px solid #3F3362;
          img {
            transform: rotate(180deg);
          }
        }
      }
    }
  }

  .collapse-enter-active, .collapse-leave-active {
    max-height: 300px;
    transition: all .4s ease-out;
  }

  .collapse-enter, .collapse-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .voice-modal {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100vw;
    background-color: rgba(14,20,31,0.95);

    img {
      position: absolute;
      top: 19.5px;
      right: 24px;

      width: 16px;
      height: 16px;
    }

    h2 {
      margin: 0;

      position: absolute;
      top: 90px;
      left: 24px;
      font-size: 24px;
    }

    .top-span {
      position: absolute;
      top: 160px;
      left: 24px;
      opacity: 0.9;

      font-size: 15px;
      line-height: 30px;
    }

    .release-up {
      opacity: 0.7;
    }

    .error {
      font-size: 15px;
      line-height: 30px;

      .rec {
        margin-top: 40px;
        opacity: 0.7;
        line-height: 40px;
      }
    }

    .siri-wave {
      position: absolute;
      bottom: 78px;
      user-select: none;
    }

    footer {
      position: absolute;
      left: calc(~'50% - 27px');
      bottom: 20px;
      .mic-btn {
        margin: 0 auto;
        width: 54px;
        height: 54px;
        line-height: 54px;
        text-align: center;

        border-radius: 50%;
        background: radial-gradient(50% 112%, rgba(30,97,182,0.00) 54%, rgba(30,97,182,0.05) 76%, rgba(30,97,182,0.13) 83%, rgba(30,97,182,0.23) 90%, rgba(30,97,182,0.70) 100%);
        box-shadow: 0 0 45px 0 rgba(109,174,255,0.20);

        i {
          font-size: 22px;
          color: #32B5FF;
        }
      }
    }
  }
}

.search-results {
  height: calc(~'100% - 100px');

  .categories {
    width: 100%;
    overflow: auto;
    white-space: nowrap;
    line-height: 60px;
    height: 60px;

    li {
      margin-right: 10px;
      display: inline;
      border: none;
      opacity: 0.7;
    }

    .current {
      opacity: 1;
      border-bottom: 1px solid #6378FF;
    }
  }

  .results {
    height: calc(~'100% - 50px');
    overflow: auto;

    .label {
      opacity: 0.4;
      font-size: 13px;
    }
  }
}

.nav-list {
  height: calc(~'100% - 60px');
  overflow: auto;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

.language-toggle {
  text-align: center;
  margin: 20px 0;
  line-height: 46px;
  height: 50px;
  padding-bottom: 10px;
  //border: 1px solid #3F3362;
  border: 1px solid rgba(255,255,255,.1);

  .none {
    opacity: 0.4;
  }
}
</style>



// WEBPACK FOOTER //
// mobile-search.vue?04e3e6f8